import { render, staticRenderFns } from "./VisaStep.vue?vue&type=template&id=07ab6a91&scoped=true"
import script from "./VisaStep.vue?vue&type=script&lang=js"
export * from "./VisaStep.vue?vue&type=script&lang=js"
import style0 from "./VisaStep.vue?vue&type=style&index=0&id=07ab6a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ab6a91",
  null
  
)

export default component.exports